import {
  BaseQueryApi,
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { logOut } from "../slices/authSlice";

export const getBaseURL = () => {
  return process.env.REACT_APP_API_URL;
};

const QUERY = fetchBaseQuery({
  baseUrl: getBaseURL(),
  prepareHeaders: (headers, { getState }) => {
    const { accessToken } = (getState() as { auth: { accessToken: string } })
      .auth;
    if (accessToken != null) {
      headers.set("Authorization", `Bearer ${accessToken}`);
    }

    return headers;
  },
});

const baseQueryWithReauth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: {},
) => {
  const result = (await QUERY(args, api, extraOptions)) as any;

  if (
    (result.error && result.error.status === 401) ||
    (result.error && result.error.status === 403)
  ) {
    // Dispatch logout action
    api.dispatch(logOut());
  }

  return result;
};

export const API = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  keepUnusedDataFor: 0.0001,
  tagTypes: [],
});
